/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSubscriptionFlowStatePlanInfo
 */
export interface GetSubscriptionFlowStatePlanInfo {
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionFlowStatePlanInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionFlowStatePlanInfo
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionFlowStatePlanInfo
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionFlowStatePlanInfo
     */
    trialDays: number;
}

/**
 * Check if a given object implements the GetSubscriptionFlowStatePlanInfo interface.
 */
export function instanceOfGetSubscriptionFlowStatePlanInfo(value: object): value is GetSubscriptionFlowStatePlanInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('trialDays' in value) || value['trialDays'] === undefined) return false;
    return true;
}

export function GetSubscriptionFlowStatePlanInfoFromJSON(json: any): GetSubscriptionFlowStatePlanInfo {
    return GetSubscriptionFlowStatePlanInfoFromJSONTyped(json, false);
}

export function GetSubscriptionFlowStatePlanInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionFlowStatePlanInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'price': json['price'],
        'trialDays': json['trialDays'],
    };
}

export function GetSubscriptionFlowStatePlanInfoToJSON(json: any): GetSubscriptionFlowStatePlanInfo {
    return GetSubscriptionFlowStatePlanInfoToJSONTyped(json, false);
}

export function GetSubscriptionFlowStatePlanInfoToJSONTyped(value?: GetSubscriptionFlowStatePlanInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'price': value['price'],
        'trialDays': value['trialDays'],
    };
}

